import { useState } from "react";
import styles from "./EvaluationList.module.css";

import ListToolbar from "../../Utils/ListToolbar/ListToolbar";

import Pagination from "../../Utils/Pagination/Pagination";
import usePagination from "../../Utils/Hooks/usePagination";

import { useAuth } from "../../../../Context/AuthContext";
import { fetchAllSelfPublishings, deleteSelfPublishing } from "../../../../Api/Backend/SelfPublishing";


function EvaluationList({ onItemClickHandle }) {
  const auth = useAuth();
  // const [selfPublishings, setSelfPublishings] = useState([]);

  const getDefaultDateFrom = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 3);
    return date.toISOString().split("T")[0];
  };

  const getDefaultDateTo = () => {
    return new Date().toISOString().split("T")[0];
  };

  const [search, setSearch] = useState("");
  const [methodFilter, setMethodFilter] = useState("");
  const [dateFrom, setDateFrom] = useState(getDefaultDateFrom);
  const [dateTo, setDateTo] = useState(getDefaultDateTo);

  const PUBLISHING_METHOD_OPTIONS = [
    { value: "jabi", label: "자비 출판" },
    { value: "jabi-amazon", label: "자비 출판 + 아마존 킨들" },
    { value: "amazon", label: "아마존 킨들" },
  ];

  const formatDateString = (dateString) => {
    const date = new Date(dateString);
    return date.toISOString().split("T")[0];
  };

  // const handleFetchAllSelfPublishings = async () => {
  //   await fetchAllSelfPublishings({
  //     auth: auth,
  //     onSuccess: (result) => {
  //       console.log("Result: ", result);
  //       setSelfPublishings(result);
  //     },
  //     onError: (error) => {
  //       console.log("Error: ", error);
  //     }
  //   })
  // };

  // useEffect(() => {
  //   handleFetchAllSelfPublishings();
  // }, []);

  const { content, page, setPage, totalPages, refresh } = usePagination(
      ({ page, size, onSuccess, onError }) => fetchAllSelfPublishings({ auth, page, size, onSuccess, onError }),
      { pageSize: 10 }
  );

  const filtered = content.filter(s => {
    const matchesSearch = !search ||
      s.title?.toLowerCase().includes(search.toLowerCase()) ||
      s.submitter?.toLowerCase().includes(search.toLowerCase()) ||
      s.author?.toLowerCase().includes(search.toLowerCase());
    const matchesDate =
      (!dateFrom || formatDateString(s.dateCreated) >= dateFrom) &&
      (!dateTo || formatDateString(s.dateCreated) <= dateTo);
    const matchesMethod = !methodFilter || s.publishingMethod === methodFilter;
    return matchesSearch && matchesDate && matchesMethod;
  });

  const handleDelete = async (selfPublishingId) => {
      if (!window.confirm("정말 삭제하시겠습니까?")) return;
      await deleteSelfPublishing({
          auth,
          selfPublishingId,
          onSuccess: () => refresh(),
          onError: (e) => alert("삭제에 실패했습니다.")
      });
  };

  return (
    <div className={styles.container}>
      <ListToolbar
        search={search}
        onSearchChange={setSearch}
        typeFilter={methodFilter}
        onTypeChange={setMethodFilter}
        typeOptions={PUBLISHING_METHOD_OPTIONS}
        allTypesLabel="전체 출판 방식"
        dateFrom={dateFrom}
        onDateFromChange={setDateFrom}
        dateTo={dateTo}
        onDateToChange={setDateTo}
      />
      <table className={styles.table}>
        <thead>
          <tr>
            <th>도서명(가제)</th>
            <th>저자명</th>
            <th>제출자</th>
            <th>제출일</th>
            <th>작업</th>
          </tr>
        </thead>
        <tbody>
          {filtered.length > 0 ? filtered.map((selfPublishing, index) => (
            <tr key={index}>
              <td>{selfPublishing.title}</td>
              <td>{selfPublishing.author}</td>
              <td>{selfPublishing.email}</td>
              <td>{formatDateString(selfPublishing.dateCreated)}</td>
              <td>
                <button
                  onClick={() =>
                    onItemClickHandle(selfPublishing)
                  }
                  className={styles.viewButton}
                >
                  상세보기
                </button>
                <button
                    onClick={() => handleDelete(selfPublishing.selfPublishingId)}
                    className={styles.deleteButton}
                >
                    삭제
                </button>
              </td>
            </tr>
          )) : (
            <tr>
              <td colSpan={5} className={styles.empty}>검색 결과가 없습니다.</td>
            </tr>
          )}
        </tbody>
      </table>
      <div className={styles.pagination}>
        <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
      </div>
    </div>
  );
}

export default EvaluationList;